<template>
  <section class="section world-map-section reveal-section" id="mapa" ref="sectionRef">
    <div class="section-header">
      <span class="section-label" style="color:var(--vh-dorado)">Global</span>
      <h2 class="section-title" style="color:white">Un Mundo por Alcanzar</h2>
      <p class="section-subtitle" style="color:rgba(255,255,255,0.8)">Nuestra presencia y impacto en el mundo entero</p>
    </div>

    <div class="stats-grid">
      <div class="stat-box" style="animation-delay:0.1s">
        <h3>24</h3>
        <p>Países Alcanzados</p>
      </div>
      <div class="stat-box" style="animation-delay:0.2s">
        <h3 style="color:var(--vh-verde)">150K+</h3>
        <p>Personas Impactadas</p>
      </div>
      <div class="stat-box" style="animation-delay:0.3s">
        <h3 style="color:var(--vh-rosa)">500+</h3>
        <p>Comunidades</p>
      </div>
      <div class="stat-box" style="animation-delay:0.4s">
        <h3 style="color:var(--vh-azul-cielo)">50+</h3>
        <p>Programas Activos</p>
      </div>
    </div>

    <div class="map-container">
      <svg viewBox="0 0 1200 600" class="map-svg">
        <defs>
          <filter id="glow"><feGaussianBlur stdDeviation="3" result="coloredBlur"/><feMerge><feMergeNode in="coloredBlur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
          <pattern id="grid" width="60" height="60" patternUnits="userSpaceOnUse"><path d="M 60 0 L 0 0 0 60" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></pattern>
          <linearGradient id="grad-america" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#D45170;stop-opacity:0.6"/><stop offset="100%" style="stop-color:#AF1627;stop-opacity:0.4"/></linearGradient>
          <linearGradient id="grad-europe" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#3DC292;stop-opacity:0.6"/><stop offset="100%" style="stop-color:#1a8659;stop-opacity:0.4"/></linearGradient>
          <linearGradient id="grad-africa" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#FBA636;stop-opacity:0.6"/><stop offset="100%" style="stop-color:#e89520;stop-opacity:0.4"/></linearGradient>
          <linearGradient id="grad-asia" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" style="stop-color:#5DADE2;stop-opacity:0.6"/><stop offset="100%" style="stop-color:#2a5ea8;stop-opacity:0.4"/></linearGradient>
        </defs>
        <rect width="1200" height="600" fill="rgba(15,45,90,0.3)"/><rect width="1200" height="600" fill="url(#grid)"/>
        <g class="continent"><path d="M 150 100 L 200 80 L 220 150 L 210 250 L 180 280 L 140 240 L 130 150 Z" fill="url(#grad-america)" stroke="rgba(255,255,255,0.4)" stroke-width="2"/></g>
        <g class="continent"><path d="M 480 120 L 520 100 L 540 140 L 530 180 L 490 170 L 470 150 Z" fill="url(#grad-europe)" stroke="rgba(255,255,255,0.4)" stroke-width="2"/></g>
        <g class="continent"><path d="M 520 180 L 570 160 L 590 250 L 560 320 L 520 300 L 510 220 Z" fill="url(#grad-africa)" stroke="rgba(255,255,255,0.4)" stroke-width="2"/></g>
        <g class="continent"><path d="M 550 100 L 750 80 L 800 180 L 680 220 L 600 180 Z" fill="url(#grad-asia)" stroke="rgba(255,255,255,0.4)" stroke-width="2"/></g>
        <!-- Marcadores -->
        <circle cx="170" cy="240" r="6" fill="var(--vh-rosa)" class="country-marker"><title>Guatemala - Sede Central</title></circle>
        <circle cx="160" cy="200" r="6" fill="var(--vh-rosa)" class="country-marker"><title>México - 2,400 jóvenes</title></circle>
        <circle cx="210" cy="260" r="6" fill="var(--vh-rosa)" class="country-marker"><title>Colombia - 3,100 jóvenes</title></circle>
        <circle cx="200" cy="370" r="6" fill="var(--vh-rosa)" class="country-marker"><title>Argentina - 3,600 jóvenes</title></circle>
        <circle cx="490" cy="130" r="6" fill="var(--vh-verde)" class="country-marker"><title>España - 1,900 jóvenes</title></circle>
        <circle cx="530" cy="110" r="6" fill="var(--vh-verde)" class="country-marker"><title>Alemania - 2,700 jóvenes</title></circle>
        <circle cx="550" cy="220" r="6" fill="var(--vh-dorado)" class="country-marker"><title>Nigeria - 3,500 jóvenes</title></circle>
        <circle cx="575" cy="300" r="6" fill="var(--vh-dorado)" class="country-marker"><title>Kenia - 2,800 jóvenes</title></circle>
        <circle cx="720" cy="140" r="6" fill="var(--vh-azul-cielo)" class="country-marker"><title>India - 4,200 jóvenes</title></circle>
        <circle cx="820" cy="100" r="6" fill="var(--vh-azul-cielo)" class="country-marker"><title>Filipinas - 2,100 jóvenes</title></circle>
      </svg>
    </div>

    <div class="map-legend">
      <div class="legend-item" style="border-color:var(--vh-rosa)">
        <p class="legend-title">🌎 América Latina</p>
        <p class="legend-desc">13 países | 35K+ jóvenes</p>
      </div>
      <div class="legend-item" style="border-color:var(--vh-verde)">
        <p class="legend-title">🌍 Europa</p>
        <p class="legend-desc">8 países | 16K+ jóvenes</p>
      </div>
      <div class="legend-item" style="border-color:var(--vh-dorado)">
        <p class="legend-title">🌍 África</p>
        <p class="legend-desc">7 países | 17K+ jóvenes</p>
      </div>
      <div class="legend-item" style="border-color:var(--vh-azul-cielo)">
        <p class="legend-title">🌏 Asia & Oceanía</p>
        <p class="legend-desc">12 países | 24K+ jóvenes</p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useScrollReveal } from '@/composables/useAnimations'

const sectionRef = ref<HTMLElement | null>(null)
const { registerReveal } = useScrollReveal()
onMounted(() => registerReveal(sectionRef.value))
</script>

<style scoped>
.world-map-section {
  background: linear-gradient(135deg, var(--vh-azul-oscuro), var(--vh-azul-profundo));
  position: relative;
  overflow: hidden;
  padding: 7rem 5%;
}
.world-map-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 20% 50%, rgba(93,173,226,0.15) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(251,166,54,0.1) 0%, transparent 50%);
  pointer-events: none;
}
.section-header {
  text-align: center;
  margin-bottom: 5rem;
  position: relative;
  z-index: 1;
}
.section-label {
  display: inline-block;
  font-weight: 700; font-size: 0.8rem;
  text-transform: uppercase; letter-spacing: 3px;
  margin-bottom: 1rem; font-family: 'Barlow', sans-serif;
}
.section-title {
  font-size: clamp(2.2rem, 4vw, 3.2rem);
  margin-bottom: 1.2rem; line-height: 1.1;
}
.section-subtitle {
  max-width: 650px;
  margin: 0 auto; font-size: 1.15rem; line-height: 1.8;
}
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto 4rem;
  text-align: center;
  position: relative;
  z-index: 2;
}
.stat-box {
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid rgba(255,255,255,0.2);
  animation: fadeInUp 0.8s ease both;
}
.stat-box h3 {
  font-size: 2.5rem;
  color: var(--vh-dorado);
  margin-bottom: 0.5rem;
  font-family: 'League Spartan', sans-serif;
  font-weight: 800;
}
.stat-box p {
  color: rgba(255,255,255,0.8);
  font-weight: 600;
  margin: 0;
}
.map-container {
  max-width: 1200px;
  margin: 0 auto;
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(10px);
  padding: 2rem;
  border-radius: 20px;
  border: 1px solid rgba(255,255,255,0.2);
  position: relative;
  animation: fadeInUp 0.8s ease 0.5s both;
}
.map-svg {
  width: 100%;
  height: auto;
  display: block;
}
.continent {
  opacity: 0.5;
  transition: opacity 0.3s;
}
.continent:hover {
  opacity: 0.8;
}
.country-marker {
  cursor: pointer;
  transition: all 0.3s;
}
.country-marker:hover {
  r: 10;
  filter: drop-shadow(0 0 8px rgba(255,255,255,0.8));
}
.map-legend {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 3rem auto 0;
  text-align: center;
  position: relative;
  z-index: 2;
}
.legend-item {
  background: rgba(255,255,255,0.1);
  backdrop-filter: blur(10px);
  padding: 1.5rem;
  border-radius: 12px;
  border-left: 4px solid;
  transition: var(--vh-transicion);
}
.legend-item:hover {
  transform: translateY(-5px);
  background: rgba(255,255,255,0.15);
}
.legend-title {
  color: rgba(255,255,255,0.9);
  font-weight: 600;
  margin: 0;
}
.legend-desc {
  color: rgba(255,255,255,0.6);
  font-size: 0.9rem;
  margin: 0.5rem 0 0 0;
}

@media (max-width: 768px) {
  .map-container { padding: 1rem; }
  .stats-grid { grid-template-columns: repeat(2, 1fr); }
}
</style>
